import React, { useEffect, useState } from 'react';
import { useCheckAuth } from '../hooks/useAuth';
import { useAppSelector } from '@/store';
import Loader from '@/components/common/Loader';
import { LoadingStatus } from '@/types';

interface AuthWrapperProps {
  children: React.ReactNode;
}

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { status } = useAppSelector((state) => state.auth);
  const [authCheckComplete, setAuthCheckComplete] = useState(false);
  const { loading, called } = useCheckAuth();

  // Wait for auth check to complete before rendering children
  useEffect(() => {
    if (called && !loading) {
      setAuthCheckComplete(true);
    }
  }, [called, loading]);

  if (!authCheckComplete || status === LoadingStatus.LOADING) {
    return (
      <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-black bg-opacity-90">
        <Loader size="large" variant="white" />
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthWrapper; 